import * as React from "react"
import i18n from 'i18n'
import AsyncSelectHotels from "./AsyncSelectHotels"

import { FORM_URL } from 'app/@common/constants'


export default function SelectAsyncHotels({ ...props }) {

    const myProps = {
        urlAjax: FORM_URL.HOTEL,
        placeholder: i18n.t('common:filters.allHotels'),
        icon: { icon: 'hotel' },
        isClearable: true,
        isMulti: true,
        limitedChips: true,
        extraParams: {
            ...props.userID && { userID: props.userID }
        },
        ...props
    }

    return <AsyncSelectHotels {...myProps} />
}